import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: "Mythicplay tripled our reach into the cozy fantasy segment within two moons. The audience quality is unlike anything we've seen on standard ad networks.",
  author: 'Elowen Thrace',
  role: 'Lead Syndication Editor',
  company: 'Grimoire Weekly'
}, {
  quote: 'The Oracle Dashboard revealed audience patterns we never knew existed. We finally understand how our grimdark readers traverse between podcasts and written lore.',
  author: 'Cassiel Voss',
  role: 'Founder',
  company: 'Ironveil Studios'
}, {
  quote: "Finally, a network that speaks our language. The lore-matched advertising ensures our immersive content isn't interrupted by mundane, jarring promotions.",
  author: 'Isolde Maren',
  role: 'Content Director',
  company: 'Wyrmlight Publishing'
}];
export const Testimonials = () => {
  return <section className="py-24 bg-burgundy-900 relative" data-id="element-213">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-gold-500 mb-4" data-id="element-216">
            Words from the Realm
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-217">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-parchment-100 p-8 relative texture-overlay border border-burgundy-800/20 shadow-xl" data-id="element-218">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-burgundy-900/10" data-id="element-219" />

              <p className="text-burgundy-900 text-xl italic leading-relaxed mb-8 relative z-10 font-medium" data-id="element-220">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-burgundy-900/20 pt-4 relative z-10" data-id="element-221">
                <h4 className="font-heading font-bold text-burgundy-950 text-lg" data-id="element-222">
                  {testimonial.author}
                </h4>
                <p className="text-burgundy-800 text-sm" data-id="element-223">
                  {testimonial.role},{' '}
                  <span className="italic" data-id="element-224">{testimonial.company}</span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};